import React from "react";
import header from "../../assets/dapp-store-img.png";
import "./DApp.css";

const DApp = () => {
  return (
    <div className="DApp-container">
      <div className="DApp-images">
        <img src={header} alt="DApp" />
      </div>

      <div className="DApp-content">
        <h1 className="DApp-title">A DApp Store</h1>
        <p className="DApp-description">
          You can find your favorite decentralized applications, discover the
          latest and hottest ones and use them without leaving the wallet.
        </p>
        <p className="DApp-description">
          DApp Browser integrated, you can always access the DApps with your
          links.
        </p>

        <div className="DApp-buttons">
          <div>
            <h4>DeFi</h4>
            <p>Supported</p>
          </div>
          <div>
            <h4>NFT</h4>
            <p>Supported</p>
          </div>
          <div>
            <h4>DApp</h4>
            <p>Supported</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DApp;
